'use strict';

import { Carousel } from './carousel'

function isValid() {
  return (document.querySelector( '.carousel' ) !== null);
}

function buildCarousel() {
  new Carousel(
    {
      carousel_name 				: 'productCarousel',
      carousel_container 		: '#carousel-wrapper', // required
      slidesPerView 				: 1,
      slidesPerGroup 				: 1,
      pip_type 							: 'thumbnails',
      display_pips 					: true,
      effect                : 'fade',
      pip_clickable 				: true,
      display_arrows 				: true,
      allow_zoom 						: true,
      loop  			          : false,
      allow_deletion 				: false,
      keyboardControl       : true,
      enlargeView           : true,
      nextSlideMessage      : 'Next Image',
      prevSlideMessage      : 'Previous Image',
      items_data 						: 'page',
      items_select					: [
        document.querySelectorAll('#carousel-wrapper img, .product-images__item img, .product-video-container .product-video, .product-media__item img, .product-media__item .product-video')
      ],
      remove_elements 			: [
        document.querySelectorAll('#carousel-wrapper img, #carousel-wrapper a, a[href="#carousel-wrapper"], .product-images__item, .product-video-container, .product-media__item')
      ]
    }
  )
}

export default {
  isValid,
  buildCarousel
};
